import * as React from 'react';
export const commercebankSvg = React.forwardRef(function commercebankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#03694A',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M23.78 6.777c-.1.499-.464 1.032-1.094 1.553 1.05 1.541 1.933 3.513 2.453 6.028 1.38-.725 2.087-1.382 2.385-1.835a11.726 11.726 0 0 0-3.733-5.757l-.011.011Zm-6.052-2.674c1.38.6 3.015 1.7 4.44 3.513.762-.499 1.093-.974.994-1.326a11.867 11.867 0 0 0-5.434-2.187Zm10.039 9.405c-.464.737-1.358 1.417-2.419 2.006.332 2.29.177 4.25-.265 5.904 1.193-.725 1.977-1.439 2.364-1.915.585-1.87.729-3.91.32-5.972v-.023ZM16.325 4.001a12.637 12.637 0 0 0-2.342.193c1.116.668 2.187 2.833 3.06 5.337 1.855-.43 3.28-.94 4.285-1.439-1.723-2.278-3.7-3.536-5.003-4.09Zm5.555 4.896c-1.05.645-2.53 1.246-4.484 1.745.519 1.643.95 3.365 1.248 4.85.066.34.132.702.199 1.065 2.341-.567 4.097-1.179 5.412-1.768-.497-2.414-1.359-4.351-2.375-5.892Zm-2.816 8.986c.276 1.926.464 4.022.442 5.824 1.834-.476 3.38-1.1 4.606-1.745.497-1.643.696-3.615.364-5.995-1.811.873-3.91 1.542-5.412 1.904v.012Zm-3.28-8.08c-1.05-3.343-2.077-5.213-2.585-5.45-.806.203-1.569.475-2.286.827-.464.827-.972 2.685-1.138 5.133 1.7.057 3.822-.09 6.008-.51Zm7.764 13.667a19.525 19.525 0 0 1-4.098 1.495c-.088 1.11-.276 2.051-.607 2.674.828-.204 1.623-.51 2.363-.872a11.023 11.023 0 0 0 2.342-3.298ZM13.52 25.634c.695 1.121 1.358 1.926 1.855 2.357.85.034 1.734-.023 2.607-.182.187-.362.33-1.258.353-2.606-1.635.329-3.28.453-4.816.43Zm9.376.124a12.337 12.337 0 0 0 3.844-4.498c-.541.543-1.259 1.099-2.143 1.643a11.547 11.547 0 0 1-1.7 2.867v-.012Zm-12.248-6.867a26.63 26.63 0 0 0 2.253 5.677 31.414 31.414 0 0 0 5.423-.578c-.055-1.54-.232-3.49-.608-5.813-1.093.182-4.064.623-7.069.726v-.012ZM9.94 5.712a12.439 12.439 0 0 0-3.898 3.694c.088.374 1.049.692 2.507.839.254-1.915.762-3.513 1.392-4.533Zm2.132 19.865c-1.855-.125-3.446-.453-4.45-.895a11.913 11.913 0 0 0 6.46 3.184c-.651-.533-1.347-1.303-2.01-2.29Zm-3.258-8.091a22.667 22.667 0 0 1-.364-6.3c-1.359-.193-2.42-.533-2.872-1.009a12.125 12.125 0 0 0-1.535 6.98c.43.306 2.23.6 4.837.612a10.32 10.32 0 0 1-.066-.283Zm.331 1.428c-1.955-.012-3.8-.227-4.98-.805.021.114.032.238.065.363a11.795 11.795 0 0 0 2.607 5.383c.541.305 2.275.634 4.584.702-.895-1.53-1.712-3.456-2.276-5.643Zm8.152-3.128a64.095 64.095 0 0 0-1.16-4.861c-2.01.408-4.385.532-6.395.385a27.105 27.105 0 0 0 .497 5.825c.033.204.088.408.133.6a42.233 42.233 0 0 0 7.135-.884c-.067-.35-.133-.702-.2-1.065h-.01Z',
      fill: '#FEFEFE',
    }),
  );
});
commercebankSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var commercebank = {
  category: 'brand',
  colorable: false,
  name: 'commercebank',
  svg: commercebankSvg,
};
